import * as React from "react"
import { Container } from "react-bootstrap"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Table from "../../components/Table"

import useIslamicMosquesData from "../../hooks/useIslamicMosquesData.js"

const IslamicMosquesPage = ({location}) => {
	const columns = [
		{ name: "English Name", key: "english_name_I" },
		{ name: "Malay Name", key: "chinese_name_I" },
		{ name: "Address", key: "full_address" },
	]

	const data = useIslamicMosquesData()

	return (
		<Layout location={location}>
			<Seo title="Index of Islamic Mosques" />

			<Container>
				<h1>Islamic Mosques</h1>

				<Table
					columns={columns}
					data={data}
					paginationSize={50}
					routeLink={() => "/map"}
					routeState={({ id }) => ({ id })}
				/>

			</Container>

		</Layout>
	)
}

export default IslamicMosquesPage
